// @file Vue composable for PostHog
import environment from '@@/bits/environment'
import { sampleByEvent } from 'posthog-js/lib/src/customizations'

const POSTHOG_TOKEN =
  environment === 'production'
    ? 'phc_Qq7IdaGdpavwycUT45k9GGcwMUjV1XIRx3zGRe1Nxrc'
    : 'phc_EPCt6qTBrd32zI0egjOAA8SoeriXYmG5y369SNYZNOh'

async function usePostHog() {
  const { posthog } = await import('posthog-js')
  posthog.init(POSTHOG_TOKEN, {
    api_host: 'https://echo.padlet.com',
    ui_host: 'https://us.posthog.com',
    autocapture: false,
    persistence: 'localStorage',
    person_profiles: 'identified_only',
    // Disable session recording by default so we can control sampling rate programmatically
    disable_session_recording: true,
    // Sample 10% of web vitals events
    before_send: sampleByEvent(['$web_vitals'], 0.1),
  })

  if (Math.random() < 0.001) {
    // 0.1% sampling
    posthog.startSessionRecording()
  }

  return { posthog }
}

export { usePostHog }
